import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import {
    AudioPlayerScope,
    fetchDirectorAudioSummary,
} from 'queries/insights/insights'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TIME } from 'utils/misc'
import { IGenericResponse } from 'utils/api'
import { useAnalytics } from '../../utils/analytics'

export const useDirectorAudioSummary = (
    shouldCallApi: boolean = true,
    scope: AudioPlayerScope,
): IGenericResponse<string> => {
    const { session, params, env } = useEssentials()
    const { trackEvent } = useAnalytics()

    const { oneHour } = TIME
    const numericLocation = params.get('locationId')?.replace(/\D/g, '') ?? ''
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.INSIGHTS_DIRECTOR_AUDIO_SUMMARY, numericLocation, scope],
        () =>
            fetchDirectorAudioSummary(
                numericLocation,
                scope,
            )({
                env,
                accessToken: session?.accessToken ?? '',
                method: 'GET',
                trackEvent,
            }),
        {
            enabled: shouldCallApi,
            staleTime: oneHour,
            cacheTime: oneHour,
            retry: false,
            refetchOnWindowFocus: false,
        },
    )
    return { data, isLoading, isError, refetch, remove, error }
}
